<template>
  <v-card>
    <v-card-title class="center mb-2">{{ dialogTitle }}</v-card-title>
    <v-card-subtitle class="text-center mb-2">{{ $t('variation.saveUpdateDescription') }}</v-card-subtitle>
    <v-card-text>
      <v-alert
        v-if="localErrorMessage"
        dense
        type="error"
        outlined
        class="mb-4"
      >
        {{ localErrorMessage }}
      </v-alert>
      <v-textarea
        v-model="form.changeDescription"
        :label="$t('variation.changeDescription')"
        dense
        outlined
        rows="3"
        :error-messages="fieldErrors.changeDescription"
        @input="handleFieldInput('changeDescription')"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        rounded
        outlined
        color="primary"
        @click="handleCancelClick"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <SubmitButton
        :label="submitLabel || $t('common.save')"
        @click="handleSaveClick"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'VariationChangeDetailsForm',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => ({
        changeDescription: ''
      })
    },
    submitLabel: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      form: {
        changeDescription: this.value.changeDescription || ''
      },
      fieldErrors: {
        changeDescription: []
      },
      localErrorMessage: this.errorMessage
    }
  },
  computed: {
    dialogTitle () {
      return this.title || this.$t('variation.saveUpdateTitle')
    }
  },
  methods: {
    validate () {
      const errors = {
        changeDescription: this.form.changeDescription && this.form.changeDescription.trim() ? [] : [this.$t('variation.changeFieldRequired')]
      }

      this.fieldErrors = errors
      this.localErrorMessage = null

      return !errors.changeDescription.length
    },
    handleFieldInput (key) {
      this.localErrorMessage = null
      if (this.fieldErrors[key].length) {
        this.validate()
      }
    },
    handleCancelClick () {
      this.$eventBus.$emit('CLOSE_MODAL')
    },
    handleSaveClick () {
      if (!this.validate()) {
        return
      }

      this.$emit('input', {
        changeDescription: this.form.changeDescription.trim()
      })
    }
  },
  watch: {
    value: {
      deep: true,
      handler (newValue) {
        this.form = {
          changeDescription: newValue.changeDescription || ''
        }
      }
    },
    errorMessage (newValue) {
      this.localErrorMessage = newValue
    }
  }
}
</script>
